export default {
    routerName: 'ユーザー管理',
    user: {
        searchName: '検索条件',
        deptName: '部門名',
        type: 'タイプ',
        loginName: 'アカウント',
        name: '氏名',
        status: '状態',
        open: '有効',
        close: '無効',
        systemUser: 'システムユーザー',
        normalUser: '普通ユーザー',
        members: '会員ユーザー',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
    },
    sortButton: {
        deptName: '部門名',
        name: '氏名',
        type: 'タイプ',
        createTime: '作成日付',
    },
    table: {
        id: 'ID',
        deptName: '部門名',
        loginName: 'アカウント',
        name: '氏名',
        mobile: '電話番号',
        createBy: '作成者',
        createTime: '作成日付',
        type: 'タイプ',
        status: '状態',
    },
};
